var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
define(["require", "exports", "lit", "lit/decorators.js", "@lit/context", "./app-context"], function (require, exports, lit_1, decorators_js_1, context_1, app_context_1) {
    "use strict";
    var _a, _b, _c, _d;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AppElement = void 0;
    class AppElement extends lit_1.LitElement {
        constructor() {
            super(...arguments);
            this.models = {};
            this.elementChildren = [];
        }
        connectedCallback() {
            this.elementChildren = Array.from(this.childNodes);
            super.connectedCallback();
        }
        loadModuleAsApplication() {
            let appFragmentJsonPromise;
            if (this.appFragmentJson) {
                if (this.appFragmentJson instanceof Promise) {
                    appFragmentJsonPromise = this.appFragmentJson;
                }
                else {
                    appFragmentJsonPromise = Promise.resolve(this.appFragmentJson);
                }
            }
            else {
                appFragmentJsonPromise = this.application
                    .getClientExtensions()
                    .getReadonlyAppFragmentStoreV1()
                    .getByTypeAndName(this.moduleType, this.moduleName);
            }
            return appFragmentJsonPromise.then((json) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                let attr = (_a = json.schema) === null || _a === void 0 ? void 0 : _a.attributes;
                if (attr && attr.generateDescriptionFromImage) {
                    attr.generateDescriptionFromImage.default = false;
                }
                const modelDefaults = this.modelDefaults;
                let appOption = {
                    appFragmentJson: json,
                    startSearch: false,
                    callback: (app) => {
                        if (this.initializedCallback) {
                            this.initializedCallback(app);
                        }
                    },
                    beforeTemplateTreeInit: (app) => {
                        for (const key of Object.keys(this.models)) {
                            app.models[key] = this.models[key];
                        }
                    },
                    modelDefaults,
                    prepareModels: (app) => {
                        // searchModelInitialized
                    },
                };
                if (this.settings) {
                    appOption = Object.assign(Object.assign({}, appOption), this.settings);
                }
                return this.application.createApplication(appOption);
            }));
        }
        createRenderRoot() {
            return this;
        }
        get slotElements() {
            return this.elementChildren;
        }
        render() {
            return (0, lit_1.html) `
      <div>
          <!--name: ${this.moduleName}, type: ${this.moduleType}, ${this.application != null} -->
        <div></div>
      </div>
    `;
        }
        firstUpdated(_changedProperties) {
            if (!this.moduleApplicationPromise) {
                this.moduleApplicationPromise = this.loadModuleAsApplication();
            }
            this.moduleApplicationPromise.then((app) => __awaiter(this, void 0, void 0, function* () {
                const rootView = yield app.rootViewPromise;
                this.rootView = rootView;
                this.rootViewEl = rootView.el;
                this.renderRoot.appendChild(this.rootViewEl);
            }));
            // console.log(this.renderRoot);
            // console.log("application at firstUpdated", this.application);
        }
    }
    exports.AppElement = AppElement;
    __decorate([
        (0, context_1.consume)({ context: app_context_1.applicationContext })
        // @property({attribute: false})
        ,
        __metadata("design:type", typeof (_a = typeof Mindbreeze !== "undefined" && Mindbreeze.Application) === "function" ? _a : Object)
    ], AppElement.prototype, "application", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "modulename" }),
        __metadata("design:type", String)
    ], AppElement.prototype, "moduleName", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "moduletype" }),
        __metadata("design:type", String)
    ], AppElement.prototype, "moduleType", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", Object)
    ], AppElement.prototype, "appFragmentJson", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", Object)
    ], AppElement.prototype, "models", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", Object)
    ], AppElement.prototype, "modelDefaults", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", Function)
    ], AppElement.prototype, "initializedCallback", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_d = typeof Record !== "undefined" && Record) === "function" ? _d : Object)
    ], AppElement.prototype, "settings", void 0);
});
